export default function getEncodedId(identificator:string){
    const endodedID = encodeURIComponent(identificator)
    return endodedID
}